export namespace SecretsManagerException {
	export class Generic extends Error {
		constructor() {
			super()
			this.message = 'Secrets manager execution failed'
		}
	}
}
